import styled from '@emotion/styled';
import { BodyBox } from '@lbcamden/lib-react';

export const SplashPageRoot = styled(BodyBox)`
  padding: ${({ theme }) => theme.spacing(3)};
  text-align: center;
`;

export const PageContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
  align-items: center;
`;

export const FooterContent = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing(3)};
  display: flex;
  flex-direction: column;
`;
